import React, { createContext, useContext } from 'react';
import { eLocalStorageKeys } from 'src/constants/AppConstants';
import { usePersistedState } from 'src/hooks/useLocalStorage';

// AG-Grid theme class names
export const AG_GRID_THEME = {
  LIGHT: 'ag-theme-alpine',
  DARK: 'ag-theme-alpine-dark'
} as const;

interface ThemeContextType {
  isDarkMode: boolean;
  setIsDarkMode: (value: boolean) => void;
  agGridTheme: string;
}

const ThemeContextInitialData: ThemeContextType = {
  isDarkMode: true,
  setIsDarkMode: () => {},
  agGridTheme: AG_GRID_THEME.DARK
};

const ThemeContext = createContext<ThemeContextType>(ThemeContextInitialData);

export const useTheme = () => useContext(ThemeContext);

interface ThemeContextProviderProps {
  children: React.ReactNode;
}

export const ThemeContextProvider = ({ children }: ThemeContextProviderProps) => {
  // Use the same localStorage key as DFPTopNavigation for consistency
  const [isDarkMode, setIsDarkMode] = usePersistedState(eLocalStorageKeys.IsDarkModeEnabled, false);

  const contextValue: ThemeContextType = {
    isDarkMode,
    setIsDarkMode,
    agGridTheme: isDarkMode ? AG_GRID_THEME.DARK : AG_GRID_THEME.LIGHT
  };

  return <ThemeContext.Provider value={contextValue}>{children}</ThemeContext.Provider>;
};
